import React, { useState } from 'react';
import SelectBox from '@components/form/SelectBox';

import useApi from '@/hooks/useApi';
import PropTypes from 'prop-types';
import { MsB2b } from '../../../api/ms-b2b';
import { MsAccount } from '../../../api/ms-account';

const propTypes = {
  editable: PropTypes.oneOfType([PropTypes.bool, PropTypes.number]),
  isRequired: PropTypes.bool,
  multiple: PropTypes.bool,
  hasError: PropTypes.oneOfType([PropTypes.bool, PropTypes.string]),
  onChange: PropTypes.func,
  loading: PropTypes.bool,
  customFilter: PropTypes.oneOfType([PropTypes.object, PropTypes.func]),
  fields: PropTypes.oneOfType([PropTypes.string, PropTypes.array]),

  value: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.number,
    PropTypes.array,
    PropTypes.object,
  ]),
  isAll: PropTypes.bool,
};

const defaultProps = {
  editable: true,
  isRequired: false,
  multiple: false,
  hasError: false,
  onChange: () => {},
  loading: false,
  customFilter: {},
  fields: '',
  value: '',
  isAll: false,
};

const limit = 10;

const CustomerReturnSearch = (props) => {
  const {
    editable = true,
    isRequired = false,
    multiple = false,
    loading: isLoadingProps = false,
    customFilter = {},
    fields = '',
    hasError = false,
    value = '',
    isAll = false,
  } = props;

  const [loading, setLoading] = useState({
    initial: false,
    loadMore: false,
  });
  const [options, setOptions] = useState([]);
  const [skip, setSkip] = useState(0);

  const getCustomers = useApi(MsAccount.getCustomers);
  const getCustomerSearch = useApi(MsB2b.getCustomerSearch);

  const onSearch = async (val, newSkip = 0) => {
    if (newSkip) {
      setLoading({ ...loading, loadMore: true });
    } else {
      setLoading({ ...loading, initial: true });
    }
    try {
      let filter = {};
      let response = '';
      if (customFilter && Object.keys(customFilter).length) {
        filter = customFilter;
      }
      if (!val && filter.keyword) {
        delete filter.keyword;
      }
      if (val) {
        filter.keyword = val;
        response = await getCustomerSearch.request({
          params: {
            filter: filter,
            skip: newSkip,
            limit: limit,
            ...(fields ? { fields } : {}),
          },
        });
      } else {
        response = await getCustomers.request({
          params: {
            filter: filter,
            skip: newSkip,
            limit: limit,
            ...(fields ? { fields } : {}),
          },
        });
      }
      if (response.status == 200 && response?.data?.data?.length) {
        const result = response.data.data.map((item) => {
          if (item._id) {
            item.id = item._id;
          }
          return item;
        });
        if (newSkip) {
          setOptions(options.concat(result));
        } else {
          if (isAll) {
            result.unshift({ id: 'all', name: 'All' });
          }
          setOptions(result);
        }
      } else {
        if (!newSkip) {
          setOptions([]);
        }
      }

      if (newSkip) {
        setLoading({ ...loading, loadMore: false });
      } else {
        setLoading({ ...loading, initial: false });
      }
    } catch (error) {
      if (newSkip) {
        setLoading({ ...loading, loadMore: false });
      } else {
        setLoading({ ...loading, initial: false });
      }
    }
  };

  return (
    <SelectBox
      label="Customer"
      options={options}
      value={value}
      placeholder={
        loading.initial || loading.loadMore ? 'Loading...' : 'Select Customer'
      }
      trackBy="id"
      labelKey="name"
      isRequired={isRequired}
      multiple={multiple}
      editable={editable && !loading.initial && !isLoadingProps}
      hasError={hasError}
      loading={loading.initial}
      loadingCallback={loading.loadMore}
      withCallback={true}
      withLoadMore={true}
      loadMoreEmpty={skip >= options.length}
      searchCallback={(val) => {
        setSkip(0);
        onSearch(val);
      }}
      onLoadMore={(val) => {
        const newSkip = skip + 10;
        setSkip(newSkip);
        onSearch(val, newSkip);
      }}
      onChange={(val) => {
        if (isAll) {
          const allValue = { id: 'all', name: 'All' };
          if (multiple) {
            if (val?.length <= 0) {
              val.push(allValue);
            } else {
              const idx = val.findIndex((c) => c.id == 'all');
              if (idx > -1 && val?.length > 1) {
                const childIdx = value?.findIndex((c) => c.id == 'all');
                if (childIdx > -1) {
                  val.splice(idx, 1);
                } else {
                  val = [allValue];
                }
              }
            }
          } else {
            if (!val?.id) {
              val = allValue;
            }
          }
        }
        props.onChange(val);
      }}
      onReady={() => {
        if (!isLoadingProps) {
          setSkip(0);
          onSearch();
        }
      }}
    />
  );
};

CustomerReturnSearch.propTypes = propTypes;
CustomerReturnSearch.defaultProps = defaultProps;

export default CustomerReturnSearch;
